import React from "react";
import {
    Modal,
    ModalBody,
    ModalFooter,
  } from "reactstrap";

export default class RecoverTerritorializationModal extends React.Component {


render (){

    return(
        <>
        {}
            <Modal size="lg" isOpen={this.props.OpenModal} fade="true" >
                <ModalBody>Recuperar seu mapa da última vez que você editou?</ModalBody>
                <ModalFooter>
                    <div className="row" >                          
                        <div className="col-12">
                            <button onClick={()=>this.props.unsavedCallback(true)} className="btn btn-primary">Sim</button>
                        </div>
                    </div>
                    <div className="row" >                          
                        <div className="col-12">
                            <button onClick={()=>this.props.unsavedCallback(false)} className="btn">Não</button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
            

        </>
    )
}


}